import {
  OLD_ROUTE_DEFAULT_LENGTH,
  ROUTE_LENGTH_WITHOUT_PROVIDER
} from './route';

export const ConstantsCasino = {
  ROUTE_LENGTH_WITHOUT_PROVIDER,
  OLD_ROUTE_DEFAULT_LENGTH
};
